import bus from 'public/utils/bus'
import router from '@/layout/router/index.js'
import store from 'public/store'
import { getRenderMenuId } from 'public/utils/menu-id.js'

const USER_NUMBER = ['093263', '581437']

const getModuleOpenTime = (menuId) => {
  const recodes = window.__ERP_MENU_OPEN_TIME__
  return recodes[menuId] || null
}

const getMenu = (to) => {
  const menus = store.state.menus
  const menu = (to.meta && to.meta.tag && menus[to.meta.tag]) || null
  return menu
}

const creatTracedId = (menuId) => {
  const userId = window.__ERPUSER__ ? window.__ERPUSER__.id : '未知用户'
  return `${userId}-${menuId}`
}

const timeOrigin = performance.timeOrigin

const now = () => Math.round(timeOrigin + performance.now())

// 创建 Trace 类
class RouteTrace {
  constructor(to, from, config) {
    this.cutoff = performance.now() // 时间闸口
    this.config = {
      sampleRate: 1,
      resourceScope: { // 资源范围
        'script': 'js.load', // js
        'link': 'css.load', // css
      },
      ...config
    }
    const menu = getMenu(to)
    if (Math.random() > this.config.sampleRate || !menu) {
      this._skip = true
      return
    }
    this.creatTrace(to, from, menu)
  }

  creatTrace (to, from, menu) {
    const menuId = menu.id
    const userId = window.__ERPUSER__ ? window.__ERPUSER__.id : '未知用户'
    const menuOpenTime = getModuleOpenTime(menuId) || Date.now()
    const traceId = creatTracedId(menuId)

    this.trace = {
      traceId,
      startTime: menuOpenTime,
      endTime: null,
      duration: null,
      spans: [],
      ext: {
        userId,
        menuId,
        moduleName: menu.title || '未知模块',
        menuOpenTime,
        toPath: to.fullPath,
        fromPath: from.fullPath,
      }
    }
  }

  addSpan (item) {
    if (this._skip) return

    if (!Object.keys(this.config.resourceScope).includes(item.initiatorType)) return

    this.trace.spans.push({
      type: this.config.resourceScope[item.initiatorType], // 资源类型
      url: item.name, // 资源路径
      startTime: Math.round(timeOrigin + item.startTime), // 资源开始时间
      endTime: Math.round(timeOrigin + item.responseEnd), // 资源结束时间
      duration: item.duration, // 资源时长
      ext: {
        ...item
      }
    })
  }

  getTrace () {
    return this.trace
  }

  report (data) {
    const { startTime, endTime, duration } = data
    const { menuId, moduleName } = data.ext
    const message = `menuId=${menuId} , moduleName=${moduleName} , mountedTime=${endTime} , openTime=${startTime} , 耗时=${duration} `
    window._apm && window._apm('captureException', new Error(`【ERP-模块挂载时间上报: ${message}】: ${JSON.stringify(data)}}`))
  }

  finish (menuId) {
    if (this._skip) return

    const traceId = creatTracedId(menuId)
    if (traceId !== this.trace.traceId) return
    const endTime = now()
    this.trace.endTime = endTime
    this.trace.duration = endTime - this.trace.startTime // 模块打开耗时
    this.report(this.trace)
    this.trace = null
  }
}

let curTrace = null // 当前正在采集的 Trace
const pendingPool = new Map() // 待完结池 key = traceId

const addPoll = (trace) => pendingPool.set(trace.trace.traceId, { trace, cutoff: trace.cutoff })

const delPoll = (traceId) => pendingPool.delete(traceId)

const getPoll = (traceId) => pendingPool.get(traceId)

function findOwner (fetchStart) {
  for (const { trace, cutoff } of pendingPool.values()) {
    if (fetchStart >= cutoff) return trace // 时间闸口匹配
  }
  return null
}

const isRouteComponent = vm => {
  if (!vm.$vnode) {
    return false
  }
  // routerViewDepth = 0 是每个业务线的layout组件, 为1的是具体路由组件
  return vm.$vnode.data.routerView && vm.$vnode.data.routerViewDepth === 1
}

function isReport () {
  const user = window.__ERPUSER__ || {}
  return USER_NUMBER.includes(user.employeeNumber)
}

function report (menuId) {
  if (!isReport() || !menuId) {
    return
  }

  const traceId = creatTracedId(menuId)
  const owner = getPoll(traceId)
  if (!owner && !curTrace) return
  if (owner) {
    owner.finish(menuId)
    delPoll(traceId)
  } else {
    curTrace.finish(menuId)
    curTrace = null
  }
}

function observerResource () {
  const observer = new PerformanceObserver((list) => {
    if (!curTrace) return

    list.getEntries().forEach(entry => {
      // 池里认领
      const owner = findOwner(entry.fetchStart)
      if (owner) {
        owner.addSpan(entry)
        return
      }

      curTrace.addSpan(entry)
    })
  })
  observer.observe({ entryTypes: ['resource'] })
}

function initEvent () {
  // 监听
  observerResource()
  // 初始化前
  router.beforeEach((to, from, next) => {
    try {
      if (curTrace) {
        addPoll(curTrace)
        curTrace = null
      }
      curTrace = new RouteTrace(to, from)
    } catch (error) {
      console.error('路由挂载时间上报失败', error)
    }
    next()
  })
}

function init () {
  setTimeout(() => {
    initEvent()
  }, 2000)
}

export default {
  mounted () {
    try {
      const vm = this
      if (isRouteComponent(vm)) {
        const menuId = getRenderMenuId(vm)
        report(menuId)
      }
    } catch (error) {
      console.error('模块挂载时间上报失败', error)
    }
  }
}

bus.$once('APP_LOADED', init)



// WEBPACK FOOTER //
// ./src/layout/layout/setup/resource-log.js